<template>
  <div class="medical-record-search-bar">
    <div class="input-group">
      <label class="form-switch">
        <input type="checkbox" v-model="filter.onlyMyRecords" />
        <i class="form-icon"/> Filtrar apenas meus atendimentos
      </label>
      <input
        type="text"
        class="form-input ml-2"
        v-model="filter.search"
        :placeholder="searchPlaceholder"
      >
      <button
        type="button"
        class="btn btn-neutral btn-action input-group-btn btn-icon"
        @click="search"
        tabindex="-1"
      ><fa-icon :icon="['fal', 'search']" /></button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchPlaceholder: {
      type: String,
      default: 'Pesquisar...',
    },
  },
  data() {
    return {
      filter: {
        onlyMyRecords: false,
        search: '',
      },
    };
  },
  watch: {
    filter: {
      handler() {
        this.search();
      },
      deep: true,
    },
  },
  methods: {
    search() {
      this.$emit('search', this.filter);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.medical-record-search-bar {
  margin-bottom: $layout-spacing-lg;
  position: sticky;
  top: 4.2rem + $border-width;
  z-index: 100;

  .input-group {
    background-color: $light-color;
    border: $border-width solid $dark-blue-color-300;
    border-radius: $border-radius;
    padding: $layout-spacing;

    .form-input:first-of-type {
      border-top-left-radius: $border-radius;
      border-bottom-left-radius: $border-radius;
    }
  }

  input {
    &:focus {
      z-index: auto;
    }
  }
}
</style>
